interface NotFoundAlertProps {
  title: string
  text: string
}

export const NotFoundAlert = ({ title, text }: NotFoundAlertProps) => {
  return (
    <div className="relative bg-[url('/misc/robot-not-found.png')] bg-contain bg-start bg-no-repeat ps-32 lg:ps-35 pt-8 lg:pt-10 h-[200px] flex flex-col">
      <span className="text-lg lg:text-xl font-bold">{title}</span>
      <span className="text-md font-semibold text-gray-500 lg:max-w-sm ">
        {text}
      </span>
    </div>
  )
}
